<template>
    <div class="row">
        <div class="col-12 col-md-7 col-lg-7 scroll-y" >
          <div class="card shadow-sm ">
            <div class="card-header py-5">
              <h3 class="card-title align-items-start flex-column">
                <span class="card-label fw-bolder text-dark">{{projectData.title}} | <span class="fw-light text-gray">{{ projectData?.category?.name }}</span></span>
                <span class="text-muted mt-1 fw-bold fs-7">{{ projectData.reference }}</span>
              </h3>
              <div class="card-toolbar w-100">
                <br>
                <div class="row d-flex flex-wrap w-100">
                  <Input
                      v-for="contact in projectData.contacts"
                      :key="contact.contact_id"
                      :name="'project'+contact.contact_id+'contact'"
                      container-class="form-group col-md-6 mb-1"
                      type="text"
                      inputClass="form-control form-control-lg form-control-solid"
                      size="lg"
                      :isDisabled="true"
                      :isRequired="false"
                      v-model="contact.contact_name"
                      :is-input-group="true"
                  >
                    <template #rightAddon>
                    <span class="position-absolute border-0 badge badge-primary end-0 top-50 translate-middle">
                      {{ contact.status_name }}
                    </span>
                    </template>
                  </Input>
                </div>
              </div>
            </div>
            <div class=" card-body px-10 pb-8" style="height: 510px !important;">
                <div class="d-flex justify-content-between align-items-center mb-8 pb-10" style="border-bottom: 2px solid #CCCFD3;">
                    <div>
                        <h2>{{$t('projects.progress')}}</h2>
                        <span class="fs-4">{{$t('projects.desc_progress')}}</span>
                    </div>
                    <div class="d-flex justify-content-center align-items-center">
                      <span :class=" 'me-3 fs-4 text-' + projectData?.status_formatted?.color">{{ projectData?.status_formatted?.[locale] }}</span>
                      <div class="circle-progress-wrapper">
                          <circle-progress
                            :size="80" 
                            empty-color="#E7E6E6"
                            :show-percent="false"  
                            :unit="'%'" 
                            :percent="projectData?.progress" 
                            :fill-color="$getColor(projectData?.status_formatted?.color)"
                          />
                          <span class="progress-unit">{{ projectData?.progress }}%</span>
                      </div> 
                    </div>
                </div>

                <div class="mb-8" style="border-bottom: 2px solid #CCCFD3;">
                    <div class="d-flex justify-content-between mb-8">
                      <div v-if="project.managers?.length > 0" class="col-12 col-md-5 col-lg-5">
                        <p class="form-label fs-4 mb-2">{{$t('projects.manage_project')}}</p>
                        <div class="symbol-group symbol-hover">
                          <div v-for="manager in project?.managers" :key="manager?.id" class="symbol symbol-35px symbol-circle" :title="manager?.lastname +' '+manager?.firstname">
                            <span class="symbol-label bg-primary text-inverse-primary fw-bolder">{{manager?.initials}}</span>
                          </div>
                        </div>
                      </div>
                     
                      <div v-if="project.users?.length > 0" class="col-12 col-md-5 col-lg-5">
                        <p class="form-label fs-4 mb-2">{{$t('projects.assigned')}}</p>
                        <div class="symbol-group symbol-hover">
                          <div v-for="user in project?.users" :key="user?.id" class="symbol symbol-35px symbol-circle" :title="user?.lastname +' '+user?.firstname">
                            <span class="symbol-label bg-primary text-inverse-primary fw-bolder">{{user?.initials}}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                   <div v-if="projectData.key_word?.length > 0">
                    <p class="form-label fs-4"  >
                        {{$t('projects.keywords')}}
          
                    </p>
                    <span class="badge badge-primary fs-6 me-2" v-for="word in projectData.key_word" :key="word">{{ word }}</span>
                   </div>
                   <br>
                </div>

                <div class="d-flex justify-content-between mb-8">
                    <Input
                        name="start_date"
                        container-class="form-group col-12 col-md-5 col-lg-5"
                        type="text"
                        :label="$t('projects.start_date')"
                        labelClass="form-label fs-4"
                        inputClass="form-control form-control-lg form-control-solid"
                        size="lg"
                        :isDisabled="true"
                        :isRequired="false"
                        v-model="startDate"
                    />
                    <Input v-if="projectData.end_date"
                        name="echeance_date"
                        container-class="form-group col-12 col-md-5 col-lg-5 float-end"
                        type="text"
                        :label="$t('projects.echeance_date')"
                        labelClass="form-label fs-4"
                        inputClass="form-control form-control-lg form-control-solid"
                        size="lg"
                        :isDisabled="true"
                        :isRequired="false"
                        v-model="endDate"
                    />
                </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-5 col-lg-5">
            <Card title="projects.historics" titleClass="fw-bolder fs-2">
                <div class="card-body p-0">
                  <ScrollableListContainer
                      id="logs-scrollable-list-container"
                      :loading="gettingLogs"
                      :length="histories?.length"
                      :empty-text="$t('reports.noData')"
                      :current-page="historiesMeta.current_page"
                      :last-page="historiesMeta.last_page"
                      container-height="600px"
                      @load-next-page="loadNextHistories"
                  >
                    <template #empty>
                      <div class="text-center">
                        <Img filename="empty.png" alt="" class="mw-100 h-150px" />
                        <div class="text-gray-400 fs-4 fw-bold">{{ $t('no_data_found') }}</div>
                      </div>
                    </template>
                    <template #default>
                      <div v-for="(historic, index) in histories" :key="index">
                        <TimeLine :id="index" :historic="historic"/>
                      </div>
                    </template>
                  </ScrollableListContainer>
                </div>
            </Card>
        </div>
    </div>
</template>

<script setup> 
  import {onMounted, ref, computed, watch} from "vue";
  import {useStore} from "vuex";
  import {useLocales} from "@/composables/locales";
  import Input from "@/components/Input.vue";
  import Card from "@/components/Card"
  import TimeLine from "@/Modules/Projects/components/TimelineItem" 
  import Img from "@/components/Img.vue";
  import "vue3-circle-progress/dist/circle-progress.css";
  import CircleProgress from "vue3-circle-progress";
  import { $getColor, $dateFormatter } from "@/mixins/Helpers";
  import ScrollableListContainer from "@/components/ScrollableListContainer.vue";
  import {useRoute} from "vue-router";

  const route = useRoute()
  const store = useStore()
  const {locale} = useLocales()

  const props = defineProps({
    project: {
      type: Object,
      required: true
    },
  })

  const projectData = ref(props.project)
  const assigned = ref([])
  const gettingLogs = ref(false)

  const histories = computed(() => store.getters['projects/getCurrentProjectLogs'])
  const historiesMeta = computed(() => store.getters['projects/getCurrentProjectLogsMeta'])

  const startDate = computed(() => { 
    return $dateFormatter(projectData.value.start_date, locale.value);
  })

  const endDate = computed(() => { 
    return $dateFormatter(projectData.value.end_date, locale.value);
  })

  const getManagerName = computed(() => {
  if(projectData.value.manager_id){
    if(typeof projectData.value.manager == "string"){
      return projectData.value.manager
    }

    return projectData.value.manager?.firstname + ' ' + projectData.value.manager?.lastname
  }
  return ' '
  })

  const status = ref('')

  watch(() => props.project, (value) => {
    if(value) projectData.value = value
  }, { deep: true })

  watch(() => props.project.progress, (value) => {
    assigned.value = props.project.users
  })

  watch(() => props.project.status_formatted, (value) => {
    if(value){
      status.value = value[locale.value]
    }
  })

  function loadLogs(query) {
    gettingLogs.value = true
    store.dispatch('projects/projectLogs', query)
        .then()
        .catch()
        .finally(() => gettingLogs.value = false)
  }

  const loadNextHistories = (page) => loadLogs({id: route.params.id, page});


  const $getCssVariable = (variable) => window.getComputedStyle(document.documentElement).getPropertyValue(variable).trim()

  onMounted(() => {
    loadLogs({id: route.params.id})
    assigned.value = props.project.users
    if(props.project.status_formatted){
      status.value = props.project.status_formatted[locale.value]
    }
    if(props.project.manager_id) {
      projectData.value.manager_id = props.project.manager_id
    }
  })

</script>

<style scoped>
  .back{
    background-color: var(--bs-light-primary);
    border-radius: 8px;
    padding: 5px;
    width: auto;
  }

  .circle-progress-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .progress-unit {
    position: absolute;
    font-size: 12px;
  }
</style>